// Trivial fullscreen-quad vertex shader.
// The blob pass is intended to be driven by a PlaneGeometry(2, 2) covering NDC,
// so we pass position straight through. UVs are forwarded for completeness.
varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = vec4(position, 1.0);
}
